import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import user from "./modules/user";
import project from "./modules/project";
import resource from "./modules/resource";
import tag from "./modules/tag";
import account from "./modules/account";
import ConfigService from "@/services/ConfigService.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    Sidebar_drawer: null,
    Customizer_drawer: false,
    SidebarColor: "white", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
    SidebarBg: "",
    navbarColor: "primary",
    setHorizontalLayout: false, // Horizontal layout
    authModal: "",
    publicAuthEnabled: false
  },
  mutations: {
    SET_SIDEBAR_DRAWER(state, payload) {
      state.Sidebar_drawer = payload;
    },
    SET_CUSTOMIZER_DRAWER(state, payload) {
      state.Customizer_drawer = payload;
    },
    SET_SIDEBAR_COLOR(state, payload) {
      state.SidebarColor = payload;
    },
    SET_NAVBAR_COLOR(state, payload) {
      state.navbarColor = payload;
    },
    SET_LAYOUT(state, payload) {
      state.setHorizontalLayout = payload;
    },
    SET_AUTH_MODAL(state, payload) {
      state.authModal = payload;
    },
    SET_PUBLIC_AUTH_ENABLED(state, payload) {
      state.publicAuthEnabled = !!payload;
    },
  },
  actions: {
    toggleAuthModal({ commit, state }, show) {
      if (show && !state.publicAuthEnabled) {
        return;
      }
      commit('SET_AUTH_MODAL', show);
    },
    async loadPublicAuth({ commit }) {
      try {
        const body = await ConfigService.getPublicConfig();
        const cfg = body && body.data;
        const enabled = !!(cfg && (cfg.publicAuthEnabled === true || cfg.PublicAuthEnabled === true));
        commit('SET_PUBLIC_AUTH_ENABLED', enabled);
        return enabled;
      } catch (e) {
        commit('SET_PUBLIC_AUTH_ENABLED', false);
        return false;
      }
    }
  },
  getters: {
    authModal: (state) => state.authModal,
    publicAuthEnabled: (state) => state.publicAuthEnabled
  },
  namespace: true,
  modules: {
    auth,
    project,
    resource,
    user,
    tag,
    account
  }
});
